import fetchival from "./fetchival";

const createCacheObject = value => ({
  date: new Date(),
  value
});

const applyPostTransforms = schema => result => {
  let newResult = Promise.resolve(result);

  if (schema.transforms && schema.transforms.post) {
    newResult = schema.transforms.post.reduce(
      (acc, transformer) => acc.then(data => transformer(data, schema)),
      newResult
    );
  }

  return newResult;
};

let cachers = {};

const CACHED_FETCH = name => {
  if (!cachers[name]) {
    let cache = {};
    let requestCache = {};
    cachers[name] = cachingTime => schema => {
      const key = JSON.stringify(schema.cachingKeys || schema.endpoint);

      if (
        cache[key] &&
        (cachingTime === 0 ||
          new Date().getTime() - cache[key].date.getTime() < cachingTime)
      ) {
        return Promise.resolve(cache[key].value);
      } else {
        if (requestCache[key]) return requestCache[key];

        const call = FETCH(schema).then(result => {
          cache = {
            ...cache,
            [key]: createCacheObject(result)
          };

          delete requestCache[key];

          return result;
        });

        requestCache[key] = call;
        return call;
      }
    };
  }
  return cachers[name];
};

const STUBBED = schema => {
  return Promise.resolve(schema.stubData).then(applyPostTransforms(schema));
};

const FETCH = schema => {
  const methods = fetchival(schema.endpoint, {
    headers: schema.headers,
    responseAs: schema.as
  });

  return methods[schema.method.toLowerCase()](
    Object.keys(schema.payload).length > 0 ? schema.payload : null
  ).then(applyPostTransforms(schema));
};

const XHR = schema => {
  const req = new XMLHttpRequest();
  req.open(schema.method, schema.endpoint, true);

  Object.keys(schema.headers).forEach(key => {
    req.setRequestHeader(key, schema.headers[key]);
  });

  return {
    request: req,
    transformer: applyPostTransforms(schema),
    payload: schema.payload
  };
};

export const Resolvers = {
  CACHED_FETCH,
  FETCH,
  XHR,
  STUBBED
};

const defaults = {
  endpoint: "",
  method: "GET",
  payload: {},
  parameters: {},
  headers: {},
  resolver: FETCH,
  as: "json"
};

export const addTransforms = (schema, transforms) => ({
  ...schema,
  transforms: {
    pre: [
      ...(schema.transforms ? schema.transforms.pre : []),
      ...transforms.pre
    ],
    post: [
      ...(schema.transforms ? schema.transforms.post : []),
      ...transforms.post
    ]
  }
});

export const resolveSchema = schema => {
  let newSchema = { ...defaults, ...schema };

  if (schema.transforms && schema.transforms.pre) {
    newSchema = schema.transforms.pre.reduce(
      (acc, transformer) => transformer(acc),
      newSchema
    );
  }

  const paramNames = Object.keys(newSchema.parameters);

  const newEndpoint = paramNames.reduce(
    (acc, key) => acc.replace(`{${key}}`, newSchema.parameters[key]),
    newSchema.endpoint
  );

  const finalSchema = {
    ...newSchema,
    endpoint: newEndpoint
  };

  return finalSchema.resolver(finalSchema);
};

export default resolveSchema;



// WEBPACK FOOTER //
// ./src/services/Api/api.js